import { Routes, Route, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";

import LoanCalculator from "./component/LoanCalculator";
import Home from "./component/Home";
import TermsConditions from "./component/TermsConditions";
import AboutUs from "./component/AboutUs";
import PrivacyPolicy from "./component/policies/PrivacyPolicy";
import FAQ from "./component/FAQ";
import ContactUs from "./component/ContactUs";
import InterestRatePolicy from "./component/policies/InterestRatePolicy";
import RiskManagementPolicy from "./component/policies/RiskManagementPolicy";
import CancellationRefundPolicy from "./component/policies/CancellationRefundPolicy";
import FairPracticeCode from "./component/FairPracticeCode";
import CorporateGovernance from "./component/CorporateGovernance";
import KYCAmlPolicy from "./component/policies/KYCAmlPolicy";
// import RepaymentNow from "./component/RepayNow";
import Blogs from "./component/Blogs";
import BlogDetail from "./component/BlogDetail";
import LoanIllustrationAndRates from "./component/LoanIllustrationAndRates";
import GrievanceRedressal from "./component/GrievanceRedressal";
import HowItWorks from "./component/HowItWorks";


const ExternalRedirect = ({ to }: { to: string }) => {
  const navigate = useNavigate();
  const hasOpened = useRef(false);

  useEffect(() => {
    if (!hasOpened.current) {
      hasOpened.current = true;
      window.open(to, "_blank");
      navigate("/", { replace: true });
    }
  }, [to, navigate]);
  return null;
};

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      <Route path="/about" element={<AboutUs />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/repay" element={<ExternalRedirect to={`${import.meta.env.VITE_WEBSITE_LINK}/repay-now`} />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/blogs/:slug" element={<BlogDetail />} />
      <Route path="/loan-details" element={<LoanIllustrationAndRates />} />
      <Route path="/loan-calculator" element={<LoanCalculator />} />
      <Route path="/terms-condition" element={<TermsConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/interest-rate-policy" element={<InterestRatePolicy />} />
      <Route path="/risk-management-policy" element={<RiskManagementPolicy />} />
      <Route path="/cancellation-refund-policy" element={<CancellationRefundPolicy />} />
      <Route path="/fair-practice-code" element={<FairPracticeCode />} />
      <Route path="/grievance-redressal" element={<GrievanceRedressal />} />
      <Route path="/corporate-governance" element={<CorporateGovernance />} />
      <Route path="/kyc-aml-policy" element={<KYCAmlPolicy />} />
    </Routes>
  );
}

export default App;
